// Deps
import { motion } from "framer-motion";
import { fluid } from "~/styleguide/utils";
import { colors, gutters, layout } from "~/styleguide";
import { createComponent, FelaComponent } from "react-fela";
import get from "lodash.get";

// Component
import SubnavGroup from "./group";
import SubnavFooter from "./footer";

export default function SubNavigation({
    menuData,
    activeIndex,
    overviews,
    handleExit
}) {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="subnav-container"
            style={{width: 0}}
        >
            <FluidMinWidth onMouseLeave={handleExit}>
                <Container className="subnav">
                    <FluidMinWidth
                        extend={{
                            maxWidth: layout.navContentMaxWidth
                        }}
                    >
                        {menuData &&
                            menuData.length &&
                            menuData.map(({ child_items: children }, i) => {
                                if (activeIndex !== i) return null;

                                const overview = get(overviews, [i]);
                                const { subnav_footer_set } = overview || false;
                                const hasFooter = subnav_footer_set
                                    ? true
                                    : false;

                                return (
                                    <div key={i}>
                                        <FelaComponent
                                            style={wrapperStyles(hasFooter)}
                                            key={i}
                                        >
                                            {overview &&
                                                (overview.heading ||
                                                    overview.copy || overview.caption) && (
                                                    <SubnavGroup
                                                        heading={overview.heading}
                                                        copy={overview.copy}
                                                        second_heading={overview.second_heading}
                                                        link_content={overview.link_content}
                                                        image={overview.image}
                                                        caption={overview.caption}
                                                        isOverview={true}
                                                    />
                                                )}

                                            {children &&
                                                children.length &&
                                                children.map((child, j) => {
                                                    return (
                                                        <SubnavGroup
                                                            heading={
                                                                child.title
                                                            }
                                                            items={
                                                                child.child_items
                                                            }
                                                            key={j}
                                                            handleExit={
                                                                handleExit
                                                            }
                                                        />
                                                    );
                                                })}
                                        </FelaComponent>

                                        {subnav_footer_set &&
                                            subnav_footer_set.length && (
                                                <SubnavFooter
                                                    items={subnav_footer_set}
                                                />
                                            )}
                                    </div>
                                );
                            })}
                    </FluidMinWidth>
                </Container>
            </FluidMinWidth>
        </motion.div>
    );
}

const FluidMinWidth = createComponent(
    () => ({
        marginH: "auto",
    })
);

const Container = createComponent(
    () => ({
        background: colors.white,
        position: "absolute",
        top: 67,
        zIndex: -1,
        textAlign: "left",
        overflow: "hidden",
        border: "1px solid",
        borderColor: colors.blue,
        borderRadius: "12px",
        transform: "translateX(-40%)",
        extend: [
            fluid("paddingH", gutters.header),
            fluid("paddingV", { min: 20, max: 50 })
        ],
        "@media(max-width: 1280px)": {
            top: 64,
        }
    }),
    "div",
    ["onClick", "className"]
);

const wrapperStyles = hasFooter => ({
    display: "flex",
    justifyContent: "left",
    extend: [{ condition: hasFooter, style: { paddingBottom: 80 } }]
});
